import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
export const Route = createFileRoute("/privacy-policy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Privacy Policy | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Privacy policy for Neuro Wellness TMS Centers of America in Coral Springs, FL. How we collect, use, and protect your personal health information.",
        },
        {
          property: "og:title",
          content: "Privacy Policy | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Privacy policy for Neuro Wellness TMS Centers of America in Coral Springs, FL. How we collect, use, and protect your personal health information.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/privacy-policy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/privacy-policy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PrivacyPolicy />;
}
